import { gql } from "apollo-boost";

export const GET_SETS_LIB = gql`
  query {
    allSetsLib {
      edges {
        node {
          setId
          setName
          setDesc
          noOfSets
          noOfRep
          distance
          distanceSum
          stroke
          tag
          setInterval
          timePerDist
          timeTotal
          equipment
          sportType
          facilityType
          activityId
          workoutId
          setsLibSetId
          userId
        }
      }
    }
  }
`;
